import { render, staticRenderFns } from "./FactorialMaterialLayout.vue?vue&type=template&id=20b57e4a&scoped=true"
import script from "./FactorialMaterialLayout.vue?vue&type=script&lang=js"
export * from "./FactorialMaterialLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b57e4a",
  null
  
)

export default component.exports